// #region imports

// --- Angular
import { Injectable } from '@angular/core';

// --- HS Code
import { CommunicationsBaseService } from './communications-base.service';

// #endregion

@Injectable({
  providedIn: 'root'
})
export class CommunicationsMockService extends CommunicationsBaseService {
  override loadUserCommunicationPreferences(): void {
    throw new Error('Method not implemented.');
  }
  override setShowUpdates(value: boolean): void {
    throw new Error('Method not implemented.');
  }
  override setShowSurveyNotifications(value: boolean): void {
    throw new Error('Method not implemented.');
  }
}
